// src/components/course/CourseListItem.js
import React, { useState } from "react";
import { MapPin } from "lucide-react";

function CourseListItem({
  imageUrl,
  name,
  distance,
  startLocation,
  type,
  ratingAvg,
  onClick,
}) {
  const [imgError, setImgError] = useState(false);
  const canShowImage = imageUrl && !imgError;

  return (
    <div
      onClick={onClick}
      className="w-full bg-white rounded-[24px] shadow-[0_8px_30px_rgb(0,0,0,0.08)] mb-6 overflow-hidden cursor-pointer hover:scale-[1.02] transition-transform duration-200 border border-gray-100"
    >
      {/* 1. 상단 이미지 영역 (사진 없으면 그라디언트) */}
      <div className="h-44 w-full bg-gradient-to-br from-[#4facfe] to-[#00f2fe] relative flex items-center justify-center">
        {canShowImage ? (
          <img
            src={imageUrl}
            alt={name}
            className="w-full h-full object-cover"
            onError={() => setImgError(true)}
          />
        ) : (
          <MapPin className="text-white opacity-40 w-16 h-16" />
        )}
      </div>

      {/* 2. 하단 정보 영역 */}
      <div className="p-5">
        <div className="flex justify-between items-start mb-2">
          <h3 className="text-xl font-bold text-gray-900 leading-tight">
            {name}
          </h3>
          {/* 별점 */}
          {ratingAvg && (
            <div className="flex items-center gap-1 bg-yellow-50 px-2 py-1 rounded-lg border border-yellow-100">
              <span className="text-sm">⭐</span>
              <span className="text-sm font-bold text-yellow-600">
                {ratingAvg.toFixed(1)}
              </span>
            </div>
          )}
        </div>

        {/* 위치 정보 */}
        <div className="flex items-center gap-1 text-gray-500 text-sm mb-4">
          <MapPin className="w-4 h-4" />
          <span>{startLocation}</span>
        </div>

        {/* 태그 (거리, 타입) */}
        <div className="flex gap-2">
          <span className="px-3 py-1 bg-blue-50 text-blue-500 text-xs font-bold rounded-full">
            {distance}km
          </span>
          <span className="px-3 py-1 bg-purple-50 text-purple-500 text-xs font-bold rounded-full">
            {type === "러닝" ? "러닝" : "산책"}
          </span>
        </div>
      </div>
    </div>
  );
}

export default CourseListItem;
